export default __webpack_public_path__ + "images/643dc23fbeea4e82e17032e39ba75f8c.jpg";